
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M3 7h13v2H3V7zm0 4h20v2H3v-2zm22 0l5 5-5 5V11zM3 15h20v2H3v-2zm0 4h20v2H3v-2zm0 4h13v2H3v-2z"}})])
          )
        }
      }
    